import React from 'react';
import { formatFileSize } from '../../utils/imageCompression';

function TestResults({ results, settings }) {
  if (!results || results.length === 0) {
    return null;
  }

  // Find the best profile (lowest total time with successful upload)
  const successfulResults = results.filter(r => r.success);
  const bestResult = successfulResults.reduce((best, current) => {
    if (!best || current.totalTime < best.totalTime) {
      return current;
    }
    return best;
  }, null);

  // Format time in milliseconds
  const formatTime = (ms) => {
    if (!ms || isNaN(ms)) return 'N/A';
    return `${Math.round(ms)}ms`;
  };

  // Format network speed
  const formatNetworkSpeed = (mbps) => {
    if (!mbps || isNaN(mbps)) return 'N/A';
    return `${parseFloat(mbps).toFixed(1)} Mbps`;
  };

  return (
    <div className="test-results">
      <h4>
        📊 Test Results
        {settings && settings.compression.testResults.lastRun && (
          <span style={{ fontSize: '12px', color: '#8899a6', marginLeft: '8px', fontWeight: 'normal' }}>
            Last run: {new Date(settings.compression.testResults.lastRun).toLocaleString()}
          </span>
        )}
      </h4>

      <table className="test-results-table">
        <thead>
          <tr>
            <th>Profile</th>
            <th>Resolution</th>
            <th>Size</th>
            <th>Compression</th>
            <th>Upload</th>
            <th>Server</th>
            <th>Total</th>
            <th>Speed</th>
          </tr>
        </thead>
        <tbody>
          {results.map((result) => {
            const isBest = bestResult && result.profileId === bestResult.profileId;
            
            return (
              <tr key={result.profileId} className={isBest ? 'best' : ''}>
                <td>
                  {result.profileName}
                  {isBest && <span className="test-result-badge">BEST</span>}
                </td>
                <td>{result.resolution}</td>
                <td>{formatFileSize(result.compressedSize)}</td>
                <td>
                  {formatTime(result.compressionTime)}
                  <br />
                  <small style={{ color: '#8899a6', fontSize: '11px' }}>
                    {result.reductionPercent}% smaller
                  </small>
                </td>
                <td>{formatTime(result.uploadTime)}</td>
                <td>{formatTime(result.serverProcessingTime)}</td>
                <td>
                  <strong>{formatTime(result.totalTime)}</strong>
                </td>
                <td>
                  <div className="network-speed-bar">
                    <div className="network-speed-bar-fill">
                      <div 
                        className="network-speed-bar-fill-inner" 
                        style={{ width: `${Math.min(parseFloat(result.networkSpeed) / 50 * 100, 100)}%` }}
                      />
                    </div>
                    <span className="network-speed-value">
                      {formatNetworkSpeed(result.networkSpeed)}
                    </span>
                  </div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>

      <div style={{ marginTop: '16px', padding: '12px', backgroundColor: '#0f1419', borderRadius: '6px', fontSize: '13px', color: '#8899a6' }}>
        <strong style={{ color: '#00d4ff' }}>💡 Tip:</strong> The profile with the lowest total time is marked as BEST. 
        Consider your network speed - if you have a slow connection, choose a profile with smaller file sizes.
      </div>
    </div>
  );
}

export default TestResults;

